var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "90px",
    viewBox: "0 0 83 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CBA3835-F06C-4A74-BB1B-B331360E4335") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CNC---Cuisine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PIN",
    transform: "translate(-493.000000, -495.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/icons/locked",
    transform: "translate(493.000000, 495.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.235,38.238 C34.923,38.238 29.787,43.374 29.787,49.686 C29.787,52.256 30.646,54.718 32.198,56.709 L29.846,69.916 C29.649,71.022 29.951,72.155 30.672,73.015 C31.391,73.874 32.455,74.371 33.577,74.371 L48.897,74.371 C50.018,74.371 51.081,73.874 51.801,73.015 C52.521,72.156 52.824,71.02 52.627,69.916 L50.273,56.711 C51.824,54.721 52.685,52.258 52.685,49.686 C52.685,43.374 47.548,38.238 41.235,38.238 Z M48.896,70.583 L33.576,70.583 L36.262,55.505 C34.619,54.102 33.576,52.021 33.576,49.687 C33.576,45.458 37.005,42.028 41.235,42.028 C45.467,42.028 48.897,45.458 48.897,49.687 C48.897,52.021 47.856,54.102 46.209,55.505 L48.896,70.583 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.103,24.742 L64.695,24.742 C64.703,24.561 64.728,24.388 64.736,24.207 C65.121,11.249 54.886,0.392 41.928,0.008 C41.694,0.004 41.46,0 41.227,0 L41.225,0 C28.432,0 18.114,10.022 17.736,22.817 C17.717,23.466 17.74,24.106 17.772,24.742 L11.366,24.742 C5.099,24.742 -1.42108547e-14,29.364 -1.42108547e-14,35.047 L-1.42108547e-14,79.695 C-1.42108547e-14,85.379 5.1,90 11.366,90 L71.104,90 C77.372,90 82.473,85.379 82.473,79.695 L82.473,35.047 C82.472,29.364 77.371,24.742 71.103,24.742 Z M41.225,4.314 C41.418,4.314 41.608,4.318 41.802,4.322 C52.402,4.634 60.738,13.481 60.424,24.081 C60.418,24.304 60.385,24.519 60.373,24.742 L22.085,24.742 C22.047,24.148 22.03,23.55 22.047,22.948 C22.355,12.542 30.886,4.314 41.225,4.314 Z M78.158,79.695 C78.158,83.002 75,85.685 71.103,85.685 L11.365,85.685 C7.47,85.685 4.313,83.001 4.313,79.695 L4.313,35.047 C4.313,31.74 7.471,29.056 11.365,29.056 L18.399,29.056 L22.867,29.056 L59.597,29.056 L64.087,29.056 L71.103,29.056 C74.999,29.056 78.158,31.74 78.158,35.047 L78.158,79.695 Z"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/locked.7c316eab7c4fb106dc2b55aaca1fe4eb.svg";